import React, { useState } from "react";
import {
  Button,
  Form,
  FloatingLabel,
  Spinner,
  Container,
  Row,
  Col,
  Card,
  Image,
} from "react-bootstrap";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { Link, useNavigate } from "react-router-dom"; // Import useNavigate

import { useNotification } from "../../components/notification";
import apiService from "../../services/apiService";

import logo from "../../logo.png";

// Define validation schema using yup
const schema = yup.object().shape({
  email: yup
    .string()
    .email("Invalid email address")
    .required("Email is required"),
});

const RecoverPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema), // Integrate yup with react-hook-form
  });

  const { showNotification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate(); // Initialize useNavigate

  const onSubmit = async (data) => {
    try {
      setIsLoading(true);
      await apiService.post("/auth/forgot-password", data);
      navigate("/recover-password-confirmation", { state: { email: data.email } });
    } catch (error) {
      showNotification(
        "danger",
        error.message || "Failed to send recovery email.",
        5000
      );
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Container className="min-vh-100 d-flex align-items-center justify-content-center flex-column">
      <Row>
        <Col xs={12} className="text-center mb-4">
          <Image
            src={logo}
            alt={`${process.env.REACT_APP_PORTAL}`}
            fluid
            width="225px"
          />
        </Col>
        <Col xs={11} md={8} lg={6} xl={6} xxl={6} className="m-auto">
          <Card className="p-4 shadow border-0">
            <Card.Body>
              <h1 className="text-center mb-3 fs-5">Recover Password</h1>
              <p className="text-center mb-4 text-light-emphasis fw-light">
                Please enter your registered email to receive instructions for
                resetting your password.
              </p>
              <Form onSubmit={handleSubmit(onSubmit)}>
                <FloatingLabel
                  controlId="txtEmail"
                  label="Email"
                  className="mb-4"
                >
                  <Form.Control
                    type="email"
                    placeholder="Email"
                    {...register("email")}
                    isInvalid={!!errors.email}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.email?.message}
                  </Form.Control.Feedback>
                </FloatingLabel>
                <div className="d-grid gap-2">
                  <Button variant="primary" disabled={isLoading} type="submit" className="btn-main">
                    {isLoading ? (
                      <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </Spinner>
                    ) : (
                      "Send Recovery Email"
                    )}
                  </Button>
                </div>
              </Form>
            </Card.Body>
          </Card>
          <div className="text-center mt-3 text-light-emphasis fw-light">
            Remember Password? {" "}
            <Link to="/login" className="text-decoration-none link-secondary">
              Login
            </Link>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default RecoverPassword;